import gql from 'graphql-tag';

const addFavoriteMutation = gql`
  mutation addFavorite($input: AddFavoriteInput!) {
    addFavorite(input: $input) {
      favorite {
        id
      }
    }
  }
`;

export default addFavoriteMutation;
